import { Inbox } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiClient, type IntimacoesSummaryResponse } from '@/lib/api-client';
import { CardShell, EmptyState } from './card-shell';

/**
 * J01 v1 — Card "Intimacoes" no dashboard home.
 *
 * Mostra contagem de nao-lidas e total dos ultimos 7 dias. Click leva
 * para /escritorio/intimacoes (inbox completo).
 */
export function NewIntimationsCard() {
  const [data, setData] = useState<IntimacoesSummaryResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiClient
      .intimacoesStatsSummary()
      .then((s) => {
        if (!cancelled) setData(s);
      })
      .catch(() => {
        if (!cancelled) setData({ totalNotRead: 0, last7Days: 0 });
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <CardShell title="Intimações" icon={Inbox} bannerStyle />;
  }

  if (!data || data.totalNotRead === 0) {
    return (
      <CardShell title="Intimações" icon={Inbox}>
        <EmptyState
          icon={Inbox}
          message={
            data && data.last7Days > 0
              ? `Nenhuma intimação nova. ${data.last7Days} importadas nos últimos 7 dias.`
              : 'Nenhuma intimação nova.'
          }
          cta={{ label: 'Ver inbox', href: '/escritorio/intimacoes' }}
        />
      </CardShell>
    );
  }

  return (
    <CardShell title="Intimações" icon={Inbox}>
      <Link
        to="/escritorio/intimacoes"
        className="flex flex-col items-center gap-1 text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] rounded"
      >
        <span className="tabular-nums text-3xl font-bold text-[var(--accent)]">
          {data.totalNotRead}
        </span>
        <span className="text-xs text-[var(--fg-muted)]">
          não lidas · <span className="tabular-nums">{data.last7Days}</span> nos últimos 7 dias
        </span>
      </Link>
    </CardShell>
  );
}
